import React from "react";
import  {Title} from "../Forms/formsStyle"

function Logo(){

    return(
        <Title>Safe-Routes</Title>
    )
}

export default Logo;